import { render, staticRenderFns } from "./comment-box.vue?vue&type=template&id=b6f5ce44&"
import script from "./comment-box.vue?vue&type=script&lang=js&"
export * from "./comment-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports